import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'

export default function IuiuNavigation() {
    const navigate = useNavigate();

    return (
        <div className='buttonList'>
            <div className='interactiveText iuiuButton row left' onClick={()=>window.open("https://docs.google.com/spreadsheets/d/150gMGUrAD13XnV-JPB4eFMETQOqGrv3Z_XQiSYOvYm4/edit?gid=302182646#gid=302182646", "_blank")}>
                <div><i className='fa fa-eye'></i></div><div className='left-with-padding'>Minh ❤️ Châu (Google Sheet)</div>
            </div>
            <div className='interactiveText iuiuButton row left' onClick={()=>navigate("/iuiu")}>
                 <div><i className='fa fa-heart'></i></div><div className='left-with-padding'>IUIU</div>
            </div>
            <div className='interactiveText iuiuButton row left' onClick={()=>navigate("/blindbox/daily-blindbox")}>
                 <div><i className='fa fa-box'></i></div><div className='left-with-padding'>Blindbox</div>
            </div>
            <div className='interactiveText iuiuButton row left' onClick={()=>navigate("/mcq")}>
                 <div><i className='fa fa-tasks'></i></div><div className='left-with-padding'>Multiple Choice Question</div>
            </div>
        </div>
    )
}
